import { render } from "./Privacy.vue?vue&type=template&id=3149388f"
const script = {}
script.render = render

export default script